export default "__VITE_ASSET__2rroDhBW__"